import { createContext } from 'react';

export const PropertiesContext = createContext();
